module.exports = __webpack_public_path__ + "static/media/IIT_foundation3.84f9d85b.png";